var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-light{fill:none;}.cls-2-light{fill:#4a77f6;}.cls-3-light{fill:#668fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-light",
    d: "M7.38,14.57a1.72,1.72,0,0,0-.09,2.14l2.49-2.49A1.87,1.87,0,0,0,7.38,14.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-light",
    d: "M12.23,9.34H10.62a.45.45,0,0,0-.08.89h2.84c.12,0,.24,0,.36,0l.48-.48A2,2,0,0,1,14,9.66,3.35,3.35,0,0,0,12.23,9.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-light",
    d: "M7.38,14.57a1.87,1.87,0,0,1,2.4-.35l.48-.48a4,4,0,0,1-3.76-4,4,4,0,0,1,3.67-4v0a1.84,1.84,0,0,1,3.66-.15v.2a5.18,5.18,0,0,1,2.55,1.1,1.86,1.86,0,0,1,.33.36l3.78-3.78a12,12,0,0,0-17,17l3.78-3.78A1.72,1.72,0,0,1,7.38,14.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-light",
    d: "M24,12a12,12,0,0,0-3.51-8.49L16.71,7.29a1.72,1.72,0,0,1-.09,2.14,1.87,1.87,0,0,1-2.4.35l-.48.48a4,4,0,0,1,.09,7.94v0a1.83,1.83,0,0,1-3.66,0v0a5.18,5.18,0,0,1-2.55-1.1,1.86,1.86,0,0,1-.33-.36L3.51,20.49A12,12,0,0,0,24,12Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-light",
    d: "M16.62,9.43a1.72,1.72,0,0,0,.09-2.14L14.22,9.78A1.87,1.87,0,0,0,16.62,9.43Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-light",
    d: "M11.77,14.67h1.61a.45.45,0,0,0,.08-.89H10.62c-.12,0-.24,0-.36,0l-.48.48a2,2,0,0,1,.19.12C10.21,14.54,10.66,14.65,11.77,14.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLight);
export default __webpack_public_path__ + "static/media/payment-light.44951ec052b91f4fea1572f33cd61201.svg";
export { ForwardRef as ReactComponent };